"use client";

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/material";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Carddddss = ({ card, location }) => {
  return (
    <StyledWrapper>
      <div className="card">
        <img
          className="App-logo"
          loading="lazy"
          src={card?.photo_url || ""}
          alt={`${card?.name || ""} Service`}
        />
        <Link href={`/services/${card.slug}/${location}`}>
          <button className="App-button">{card?.name || ""}</button>
        </Link>
      </div>
    </StyledWrapper>
  );
};

function Categories({ categories = [], loading = false, language = "en", location = "" }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const text = {
    categoryTitle:
      language === "en"
        ? "India’s Most Trusted and Reliable Beauty Parlour at Your Home"
        : "भारत का सबसे विश्वसनीय और भरोसेमंद ब्यूटी पार्लर आपके घर पर",
    serviceTextFirst:
      language === "en"
        ? "We are India’s leading salon-at-home service provider, delivering professional beauty and wellness services right to your doorstep. Established in 2022, we proudly serve clients in Delhi, Noida, Gurgaon (NCR), and Bhopal. We have a team of experienced, certified, and highly trained beauticians who use premium, branded products to ensure flawless results every time. From Hair Wash, Hair Spa & Makeup to advanced facials, Spa, and Steam Bath, everything is available at the most affordable prices at your home. With a strong commitment to quality, convenience, and personalized attention, we ensure every service enhances your beauty and provides a relaxing experience."
        : "हम भारत के अग्रणी सैलून-एट-होम सेवा प्रदाता हैं, जो पेशेवर ब्यूटी और वेलनेस सेवाएं आपके दरवाजे तक पहुँचाते हैं। 2022 में स्थापित, हम दिल्ली, नोएडा, गुड़गांव (एनसीआर) और भोपाल में ग्राहकों को सेवा प्रदान करते हैं। हमारी टीम में अनुभवी, प्रमाणित, और उच्च प्रशिक्षित ब्यूटिशियन्स शामिल हैं, जो प्रीमियम, ब्रांडेड उत्पादों का उपयोग करती हैं ताकि हर बार बेहतरीन परिणाम सुनिश्चित किया जा सके। हेयर वॉश, हेयर स्पा और मेकअप से लेकर एडवांस्ड फेशियल्स, स्पा, और स्टीम बाथ तक, सब कुछ आपके घर पर सबसे किफायती कीमतों पर उपलब्ध है। गुणवत्ता, सुविधा, और व्यक्तिगत ध्यान के प्रति हमारी मजबूत प्रतिबद्धता के साथ, हम सुनिश्चित करते हैं कि हर सेवा आपके सौंदर्य को बढ़ाए और एक आरामदायक अनुभव प्रदान करें।",
    serviceTextSecond:
      language === "en"
        ? "Call us today or book your appointment to experience beauty and wellness at your convenience!"
        : "आज ही हमसे संपर्क करें या अपनी अपॉइंटमेंट बुक करें और अपनी सुविधा के अनुसार ब्यूटी और वेलनेस का अनुभव करें!",
    categoryTitleSecond:
      language === "en"
        ? "Premium-Quality Beauty Services"
        : "बाल, त्वचा और वेलनेस के लिए प्रीमियम गुणवत्ता वाली ब्यूटी सेवाएं",
    serviceTextThird:
      language === "en"
        ? ""
        : "",
  };

  return (
    <>
      <div className="bg-gray-100 lg:py-16 py-10">
        <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
          <div className="mb-10 flex justify-center" style={{ marginTop: "-55px" }}>
            <div className="text-center w-full lg:w-5/5">
              <h1
                style={{
                  fontSize: "1.4rem",
                  color: "#000000",
                  fontFamily: "Roboto, sans-serif",
                  lineHeight: "1.8",
                }}
                className="font-bold mb-1"
              >
                {text.categoryTitle}
              </h1>
              <p className="text-base leading-relaxed text-justify">{text.serviceTextFirst}</p>
              <p className="text-base leading-relaxed text-justify">{text.serviceTextSecond}</p>
            </div>
          </div>

          <div className="mb-10 flex justify-center" style={{ marginTop: "-10px" }}>
            <div className="text-center w-full lg:w-5/5">
              <h1
                style={{
                  fontSize: "1.4rem",
                  color: "#000000",
                  fontFamily: "Roboto, sans-serif",
                  lineHeight: "1.6",
                }}
                className="font-bold mb-1"
              >
                {text.categoryTitleSecond}
              </h1>
              <p className="text-base font-sans leading-6 justify-center">{text.serviceTextThird}</p>
            </div>
          </div>
        </div>

        <Container
          maxWidth="xl"
          sx={{ py: { xs: 4, lg: 12 }, px: { xs: 4, sm: 10 } }}
          className="mt-[-35px] sm:mt-[-110px]"
        >
          <Grid container spacing={2}>
            {(loading || !mounted) 
              ? Array.from({ length: 6 }).map((_, index) => (
                  <Grid item xs={3} sm={3} md={3} lg={3} key={index}>
                    <>
                      <Skeleton
                        width="100%"
                        height={25}
                        count={4}
                        style={{ marginBottom: "15px" }}
                      />
                      <Skeleton
                        width={300}
                        height={40}
                        style={{
                          marginBottom: "20px",
                          background:
                            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        }}
                      />
                      <Skeleton
                        width="100%"
                        height={15}
                        count={3}
                        style={{
                          marginBottom: "10px",
                          background:
                            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        }}
                      />
                    </>
                  </Grid>
                ))
              : categories.map((card) => (
                  <Grid item xs={12} sm={6} md={3} lg={3} key={card.id}>
                    <Carddddss card={card} location={location} />
                  </Grid>
                ))}
          </Grid>
        </Container>
      </div>
    </>
  );
}

const StyledWrapper = styled.div`
  .card {
    background-color: #ffffff;
    border: 3px solid #db2777;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: 700;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    padding: 0;
    color: #000000;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 334px;
    margin: 0;
    box-sizing: border-box;
  }

  .App-logo {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 85%;
    object-fit: cover;
    border-radius: 8px;
    margin-top: -15px;
  }

  .card .App-button {
    padding: 4px 12px;
    background-color: transparent;
    color: #db2777;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 16px;
    border: 2px solid #db2777;
    border-radius: 5em;
    margin-top: 10px;
    margin-bottom: 2px;
    transition: 0.2s;
  }

  .card .App-button:hover {
    color: #191e24;
    background-color: #ffe052;
  }
`;

export default Categories;
